(function (angular) {
	angular.module('bizPartEngage').controller('base', baseController);
	angular.module('bizPartEngage').controller('base.noaccess', baseNoaccessController);
	angular.module('bizPartEngage').controller('base.home', baseHomeController);

	baseController.$inject = ["$rootScope", "$interval", "$timeout", "$q", "base.service", "$state", "bizUser", "$translate", "fireworks", 
		"$mdDialog", "pageTitleNotification", "core.level.serivce", "bizSocialShareService", "screenSize", "bizCoreService", 
        "$stateParams", "bizHideComponentService", "bizCore", "core.services.favorite", "bizJourneyService"];
	baseNoaccessController.$inject = [];
	baseHomeController.$inject = ["$rootScope", "modules.cms.service", "$stateParams", "container", "bizContainerService",
		"bizContainerUrls", "bizContainerSettings", "MetadataService", "$filter", "$compile", "bizCoreService", "bizJourneyService", "$q"];

	function baseController($rootScope, $interval, $timeout, $q, baseService, $state, bizUser, $translate, fireworks, 
		$mdDialog, pageTitleNotification, levelService, bizSocialShareService, screenSize, bizCoreService, $stateParams, 
        bizHideComponentService, bizCoreProvider, favoriteService, bizJourneyService) {
		var vm = this;

		vm.Initialize = Initialize;
		vm.SetLanguage = SetLanguage;
		vm.GetExperienceValueFromLastCheck = GetExperienceValueFromLastCheck;
		vm.CheckForLevelUp = CheckForLevelUp;
		vm.StopAnimateExperience = StopAnimateExperience;
		vm.GainExperienceInterval = GainExperienceInterval;
        vm.ShowDialog = ShowDialog;
        vm.ShowWelcomeGuide = ShowWelcomeGuide;
		vm.DialogQueue = [];

		$rootScope.Navigate = Navigate;
		$rootScope.FocusElement = FocusElement;

		$rootScope.desktop = screenSize.is('md, lg');
		$rootScope.mobile = screenSize.is('xs, sm');
		  
		$rootScope.desktop = screenSize.on('md, lg', function(match){
			$rootScope.desktop = match;
		});
		$rootScope.mobile = screenSize.on('xs, sm', function(match){
			$rootScope.mobile = match;
		});

		$rootScope.HasAcceptedCookies = null;

		function Initialize() {
			bizHideComponentService.Hide($stateParams.hide);
            
            if ($stateParams.extmode) {                
                $rootScope.ExtMode = true;
            }

			vm.SetLanguage(bizUser);
			if (IsPortalSettingTrue('IsLevelSystemEnabled') && bizUser.IsLoggedIn()) {
				vm.GetExperienceValueFromLastCheck();
			}
			if ($rootScope.QueryParams && $rootScope.QueryParams['s']) {
				bizSocialShareService.AddSocialShareClick({
					SocialShareTrackingId: $rootScope.QueryParams['s']
				});
            }            

			baseService.GetCultures().then(GetCulturesSuccess);
			function GetCulturesSuccess(response) {
				$rootScope.Cultures = response.data;
				for (var i = 0; i < $rootScope.Cultures.length; i++)
					$rootScope.Cultures[i].QueryString = "?lang" + '=' + $rootScope.Cultures[i].CultureCode.substring(0, 2);
			}

            if (bizUser.IsLoggedIn()) {
                bizCoreService.GetUserSetting("HasAcceptedCookies").then(function (response) {
                    if (response.data === "true") {
                        $rootScope.HasAcceptedCookies = true;
                    }
                    else if (response.data === "false") {
                        $rootScope.HasAcceptedCookies = false;
                    }
                });
            }

			if ($rootScope.HasAcceptedCookies == null) {
				$rootScope.HasAcceptedCookies = getLocalStorage("HasAcceptedCookies");
			}

            if (bizUser.IsLoggedIn() && !getLocalStorage("HasShownWelcomeGuide")) {
                var welcomeGuideLayoutComponentType = 6;

                $q.all([
                    baseService.HasLayoutComponent(welcomeGuideLayoutComponentType),
                    bizCoreService.GetUserSetting("HasShownWelcomeGuide")
                ]).then(function (result) {
                    var hasWelcomeGuide = result[0].data;
                    var hasShownWelcomeGuide = result[1].data === "true";

                    if (hasWelcomeGuide && hasShownWelcomeGuide) {
                        setLocalStorage('HasShownWelcomeGuide', true);
                    } else if (hasWelcomeGuide && !hasShownWelcomeGuide) {
                        vm.ShowWelcomeGuide();
                    }
                });
            } else {
                const previewWelcomeGuidePages = getSessionStorage('previewWelcomeGuide');                
                if (previewWelcomeGuidePages) {
                    deleteSessionStorage('previewWelcomeGuide');
                }
                
                var isPreview = getParameterByNameFromUrl('wgpreview', location.href);                
                if (previewWelcomeGuidePages && isPreview === 'true') {
                    vm.ShowWelcomeGuide(JSON.parse(previewWelcomeGuidePages));
                }                
            }

			HandleFavorites(favoriteObjects);
		}

		function Navigate(state, params) {
			if(params) {
				$state.go(state, params);
			}
			else {
				$state.go(state);
			}
		}

		function FocusElement(elementId, shouldFocus) {
			if(shouldFocus === undefined || shouldFocus === true) {
				setTimeout(function(eId) {
					document.getElementById(eId).focus()
				}, 0 , elementId);
			}
		}

		function SetLanguage(user) {
			$translate.use(cultureCode.substring(0, 2)).then(function () {
				$rootScope.CultureDefer.resolve();
				moment.locale(cultureCode.substring(0, 2));
			});

			$translate.refresh();

			$rootScope.$broadcast('PORTAL_CULTURE_CHANGE');
		}

		function GetExperienceValueFromLastCheck() {
			levelService.GetExperienceValueFromLastCheck().then(GetExperienceValueFromLastCheckSuccess);

			function GetExperienceValueFromLastCheckSuccess(response) {
				if (~~response.data > 0) {
					//We have gained xp.. 
				}

				vm.CheckForLevelUp();
			}
		}

		function CheckForLevelUp() {
			levelService.CheckForLevelUp().then(CheckForLevelUpSuccess);

			function CheckForLevelUpSuccess(response) {

				if (response && response.data.length == 1 && response.data[0].RequiredExp == 0) {
					// First login, do not show fireworks, level up..?
				}
				else if (response && response.data.length == 1 && response.data[0].RequiredExp > 0) {
					levelUp(response.data[0]);
				}
				else if (response && response.data.length > 1) {
					//Need to handle level up on more then 1 different experience types...
				}
			}
		}

		vm.Initialize();

		$rootScope.$on('HUB_VIRTUAL_CURRENCY_UPDATE_DEFAULT', virtualcurrencyUpdateDefault);
		$rootScope.$on('HUB_EXPERIENCE_UPDATE_DEFAULT', experienceUpdateDefault);
		$rootScope.$on('HUB_EXPERIENCE_GAIN', experienceGain);
		$rootScope.$on('HUB_LEVEL_GAIN', levelGain);
        $rootScope.$on('HUB_NEW_CERTIFICATE', newCertificate);

        $rootScope.$on('HUB_EngageObjectFinished', function (event, args) {
            var params = JSON.parse(args.Content);
            $rootScope.$broadcast('engageobject.finished', params);
        });

        $rootScope.$on('HUB_SESSION_TIMER_REFRESH', BizPart.Client.Core.SessionTimer.Refresh);

		$rootScope.$on('CONTAINER_BUTTON_PRESSED', SetShown);
		
        $rootScope.$on('favorites.change', FavoritesChange);        

		function FavoritesChange(e, favorites) {
			HandleFavorites(favorites);
		}

		function HandleFavorites(favorites) {
			$rootScope.FavoriteTagIds = [];

			for(var i = 0; i < favorites.length; i++) {
				if(favorites[i].ObjectType == 103) {
					$rootScope.FavoriteTagIds.push(favorites[i].ObjectId);
				}
			}

			//console.log('Favorite tag ids: ', $rootScope.FavoriteTagIds);
		}

		function StopAnimateExperience() {
			$rootScope.AnimateExperience = false;
        }

        function ShowWelcomeGuide(previewPages) {

            if ($rootScope.ExtMode) {
                $rootScope.$broadcast('WELCOMEGUIDE.SHOW');
                return;
            }

            if (previewPages) {
                ShowWindow(false, previewPages);
            } else {
                bizCoreService.GetWelcomeGuide().then(function (response) {
                    if (response.data && response.data !== "" && response.data !== null) {
						const data = JSON.parse(response.data);

						if ((data.useAdvanced === undefined || data.useAdvanced === true) || data.useAdvanced === false && data.pages !== null)
							ShowWindow(data.useAdvanced, data.pages);
                    }
                });
            }            

            function ShowWindow(showAdvanced, pages) {
                if (showAdvanced === undefined) {
                    showAdvanced = true;//backwards compatibility, if setting is missing
                }
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: siteRootPath + "FrontEnd/Views/Dialogs/welcome-guide.html",
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    controller: welcomeGuideController,
                    controllerAs: "vm",
                    locals: {
                        showAdvanced: showAdvanced,
                        pages: pages
                    },
                    bindToController: true
                }).then(SetShown, SetShown);

                welcomeGuideController.$inject = ["$mdDialog"];
                function welcomeGuideController($mdDialog) {
                    var vm = this;
                }

                $rootScope.$on('WELCOMEGUIDE.COMPLETED', function (e, data) {
                    $mdDialog.hide(data);
                });
            }
		}
		
        function SetShown(data) {
            setLocalStorage('HasShownWelcomeGuide', true);
			if ($rootScope.IsLoggedIn) {
				bizCoreService.UpdateUserSetting("HasShownWelcomeGuide", true).then(function (response) {

				});
			}

            if (data && data.SelectedJourney && data.SelectedJourney.Id) {
                $rootScope.SetCurrentJourney(data.SelectedJourney.Id);
                if (data.SelectedJourney.EngageObjects && data.SelectedJourney.EngageObjects.length > 0) {
                    bizJourneyService.GoToEngageItem(data.SelectedJourney.EngageObjects[0]);
                }                
            }
		}  

		function ShowDialog(config, onshow, onclose) {
			if (vm.ShowingDialog) {
				vm.DialogQueue.push({ config: config, onshow: onshow, onclose: onclose });
				return;
			}

			vm.ShowingDialog = true;

			if (!onclose)
				onclose = function () { };

			if (onshow)
				onshow();

			var dialogPromise = $mdDialog.show({
                templateUrl: bizCoreProvider.getView('base.dialog', 'FrontEnd/Views/Dialogs/dialog-primary.html'),
				controller: dialogController,
				controllerAs: "vm",
				locals: config,
				bindToController: true
			});

			dialogPromise.then(onclose, onclose);
			dialogPromise.then(function () {
				vm.ShowingDialog = false;
				if (vm.DialogQueue.length) {
					var d = vm.DialogQueue.splice(vm.DialogQueue.length - 1, 1)[0];
					vm.ShowDialog(d.config, d.onshow, d.onclose);
				}
			});

			dialogController.$inject = ["$mdDialog"];

			function dialogController($mdDialog) {
				var vm = this;

				vm.Close = Close;

				function Close() {
					$mdDialog.hide();
				}
			}
		}

		function newCertificate(event, args) {
			var content = JSON.parse(args.Content);
			console.log(content);

			if (document.hasFocus()) {
				showNewCert(content);
			}
			else {
				pageTitleNotification.On("New certification!");
				$(window).on('focus', (function () {
					pageTitleNotification.Off();
					showNewCert(content);

					$(window).off('focus');
				}));
			}
		}

		function showNewCert(certContent) {
			vm.ShowDialog({
				Text: 'Grattis! Du har klarat av #NAME#'.replace("#NAME#", certContent.Name),
				HideButtons: true,
				CustomContentTemplateUrl: siteRootPath + "FrontEnd/Modules/Certifications/Views/new-certification-dialog.html",
				AuthToken: $rootScope.AuthToken,
				Cert: certContent
			});
		}

		function virtualcurrencyUpdateDefault(event, args) {
			$rootScope.LoggedInUser.DefaultVirtualCurrencyValue = ~~args.Content;
			$rootScope.$digest();
		}

		function experienceUpdateDefault(event, args) {
			$rootScope.LoggedInUser.DefaultExperiencePoints = ~~args.Content;
			$rootScope.$digest();
		}
		function ShowEngagementTip() {
			// vm.ShowDialog({
			// 	CustomContentTemplateUrl: siteRootPath + "FrontEnd/Views/Dialogs/engagement-tip.html",
				
			// });
		}

		ShowEngagementTip();

        function experienceGain(event, args) {
            if (!$rootScope.ShowXP) {                
                return;
            }

			var content = JSON.parse(args.Content);

			$rootScope.LoggedInUser.DefaultExperiencePointsStart = angular.copy($rootScope.LoggedInUser.DefaultExperiencePoints);

			$rootScope.AnimateExperience = true;

			$timeout(vm.StopAnimateExperience, 2500);

			vm.pointsEarned = content.TotalExperiencePoints;
			vm.ExpInterval = $interval(vm.GainExperienceInterval, 50, 0, true, (vm.pointsEarned / 50));
			vm.countedPoints = 0;
		}

		function GainExperienceInterval(amount) {
			vm.countedPoints += amount;
			$rootScope.LoggedInUser.DefaultExperiencePoints += amount;

			if (vm.countedPoints >= vm.pointsEarned) {
				$rootScope.LoggedInUser.DefaultExperiencePoints = $rootScope.LoggedInUser.DefaultExperiencePointsStart + vm.pointsEarned;
				$interval.cancel(vm.ExpInterval);
			}
		}

        function levelGain(event, args) {
            if (!$rootScope.ShowXP) {
                return;
            }

			var content = JSON.parse(args.Content);
			console.log(content);
			$rootScope.LoggedInUser.DefaultLevel = content;
			if (document.hasFocus()) {
				levelUp(content);
			}
			else {
				pageTitleNotification.On("Level up!");
				$(window).on('focus', (function () {
					pageTitleNotification.Off();
					levelUp(content);

					$(window).off('focus');
				}));
			}
		}

		function levelUp(levelContent) {
			$translate('CORE.LEVELUPDIALOG').then(function (translation) {
				var textToShow = translation.$$unwrapTrustedValue().replace("#LEVEL#", levelContent.Name);

				vm.ShowDialog({
					Text: textToShow,
					HideButtons: true
				}, function () {
					fireworks.show();
				}, function () {
					fireworks.hide();
				});
			});
		}


	}

	function baseNoaccessController() {
		var vm = this;
	}

	function baseHomeController($rootScope, cmsService, $stateParams, container, bizContainerService, bizContainerUrls, bizContainerSettings, 
        MetadataService, $filter, $compile, bizCoreService, bizJourneyService, $q) {
		var vm = this;
		vm.PageIdentifier = portalSettings['StartPageId'];
		vm.Journeys = [];
        vm.JourneyItemsPerRow = 0;

        var isStartPageDataLoaded = $q.defer();
        var isStartPageDataLoadedPromise = isStartPageDataLoaded.promise;
		
		// if (~~vm.PageIdentifier <= 0)
		// 	vm.PageIdentifier = 1;

        vm.GetCMSPage = GetCMSPage;
        vm.GoToNextJourneyItem = GoToNextJourneyItem;

        bizContainerSettings.ContainerRefererType = "CMS";

        function GoToNextJourneyItem() {
            $rootScope.GetNextJourneyItem(true).then(function (eo) {
                if(eo) 
                    bizJourneyService.GoToEngageItem(eo);
            });            
        }        

		function GetCMSPage() {
			cmsService.GetCMSPageById(vm.PageIdentifier).then(GetCmsPageSuccess);

			function GetCmsPageSuccess(response) {
				vm.Page = response.data;
				vm.Page.Container = new container(vm.Page.Container);

				var imageModules = vm.Page.Container.getModules("IMAGE");
				var imageUrl = ogDefaultImage;
				if ((!imageUrl || imageUrl == "") && imageModules.length > 0) {
					imageUrl = imageModules[0].Content.ImageUrl;
				}

				MetadataService.setMetaTags({
					title: vm.Page.Title,
					description: vm.Page.Description,
					keywords: vm.Page.Keywords,
					img: imageUrl
				});
			}
		}

		vm.GetItemWidth = GetItemWidth;

        function GetItemWidth() {
            return 100 / vm.JourneyItemsPerRow;
        }

		vm.$onInit = function () {
			
			function getStartpageDataSuccess(response) {
				if (response.data && response.data !== "" && response.data !== null) {
                    vm.StartPageData = JSON.parse(response.data);
                    console.log("startpage data", vm.StartPageData);

                    vm.StartPageData.MainBanner.Color = 'light';
                    isStartPageDataLoaded.resolve('');
				}
                else {                    
					//This is the default settings for a new portal...
					vm.StartPageData = {
						MainBanner: {
							Show: true,
							Image: { FileUrl: "" },
							ButtonLink: "",
                            ButtonType: "btn",
                            Fullscreen: true,
                            HeaderTranslations: [
                                {
                                    CultureId: currentCultureId,
                                    Value: "Lorem ipsum dolor sit amet"
                                }
                            ],
                            TextTranslations: [
                                {
                                    CultureId: currentCultureId,
                                    Value: "Donec nec enim commodo, lobortis risus sollicitudin, luctus augue. Ut ultricies placerat diam, vitae suscipit turpis volutpat a. Nulla facilisi. Phasellus varius blandit convallis."
                                }
                            ],
                            SelectedColor: {
                                Value: "dark"
                            }
						},
						BlogModule: {
							Show: true,
							Filter: "newest",
							Text: "",
							ButtonType: "btn",
                            Limit: 4,
                            HeaderTranslations: [
                                {
                                    CultureId: currentCultureId,
                                    Value: cultureCode === 'sv-SE' ? "Blogg" : "Blog"
                                }
                            ],
                            SelectedButtonType: {
                                Value: "btn"
                            }
						},
						EducationModule: {
							Show: true,
                            Filter: "newest",
							Header: "Our educations",
							Text: "",
							ButtonType: "link",
                            Limit: 4,
                            HeaderTranslations: [
                                {
                                    CultureId: currentCultureId,
                                    Value: cultureCode === 'sv-SE' ? "Här finns våra online-utbildningar" : "Our educations"
                                }
                            ],
                            SelectedButtonType: {
                                Value: "btn"
                            }
						},
						VideoModule: {
							Show: true,
                            Filter: "newest",
							Header: "Our videos",
							Text: "",
							ButtonType: "link",
                            Limit: 3,
                            HeaderTranslations: [
                                {
                                    CultureId: currentCultureId,
                                    Value: cultureCode === 'sv-SE' ? "Våra filmer" : "Our videos"
                                }
                            ],
                            SelectedButtonType: {
                                Value: "btn"
                            }
						},
						Journey: {
							Show: false,
							JourneyItemsPerRow: 10,
							View: "full",
							ShowTags: false
						}
					};
				}

				vm.JourneyItemsPerRow = ~~vm.StartPageData.Journey.ItemsPerRow;

				if (vm.JourneyItemsPerRow <= 0)
					vm.JourneyItemsPerRow = 10;

                if (vm.StartPageData.Journey && vm.StartPageData.Journey.View === 'mini') {
                    vm.miniSettings = {
                        ItemCount: ~~vm.JourneyItemsPerRow > 0 ? ~~vm.JourneyItemsPerRow : 5,
                        ShowTags: vm.StartPageData.Journey.ShowTags === true
                    };
				}

				if (vm.StartPageData.Journey && vm.StartPageData.Journey.View === 'hero') {
					if (vm.JourneyItemsPerRow < 3)
						vm.JourneyItemsPerRow = 3;
					if (vm.JourneyItemsPerRow > 4)
						vm.JourneyItemsPerRow = 4;
				}

                $rootScope.IsJourneyStarted().then((isStarted) => {
                    if (isStarted) {
                        vm.StartPageData.MainBanner.JourneyButtonTextTranslations = vm.StartPageData.MainBanner.ButtonTextSecondaryTranslations;
                    } else {
                        vm.StartPageData.MainBanner.JourneyButtonTextTranslations = vm.StartPageData.MainBanner.ButtonTextTranslations;
                    }
                });

                isStartPageDataLoaded.resolve('');
			}

			if (~~vm.PageIdentifier > 0) {
				vm.GetCMSPage();
			}
			else {
				//Get the standard startpage
                //bizCoreService.GetPortalsetting("STARTPAGE_DATA").then(getStartpageDataSuccess);

				if ($rootScope.MiniSettings.Startpage.DisableLoadData === false) {
					bizCoreService.GetStartPageData().then(getStartpageDataSuccess);
                }
            }

            var pList = [
                isStartPageDataLoadedPromise,
                $rootScope.JourneysInitialized
            ];

            $q.all(pList).then(() => {
                var journeys = [];
                if ($rootScope.Journeys) {
                    
					var maxItems = vm.JourneyItemsPerRow;
					if (vm.StartPageData.Journey && vm.StartPageData.Journey.View === 'hero' && vm.JourneyItemsPerRow > 4) {
                        maxItems = 4;                        
                    }

                    for (var i = 0; i < $rootScope.Journeys.length && i < maxItems; i++) {
                        journeys.push($rootScope.Journeys[i]);                        
                    }
                }
                vm.TotalJourneyCount = $rootScope.Journeys.length;
                vm.Journeys = journeys;
            });			
		}
	}
})(window.angular);